<template>
<div class="chapter">
<div class="inner_page">
<p class="chapter-hs"><span>CONTENTS</span></p>
<p class="toc-text"><span><a href="#/xhtml/frantmatter02">Preface</a></span></p>
<p class="toc-text"><span><a href="#/xhtml/chapter001">Lauds</a></span></p>
<p class="toc-text"><span><span href="#/xhtml/chapter002" title="Link target outside of Sample">Prime</span></span></p>
<p class="toc-text"><span><span href="#/xhtml/chapter003" title="Link target outside of Sample">Tierce</span></span></p>
<p class="toc-text"><span><span href="#/xhtml/chapter004" title="Link target outside of Sample">Sext</span></span></p>
<p class="toc-text"><span><span href="#/xhtml/chapter005" title="Link target outside of Sample">None</span></span></p>
<p class="toc-text"><span><span href="#/xhtml/chapter006" title="Link target outside of Sample">Vespers</span></span></p>
<p class="toc-text"><span><span href="#/xhtml/chapter007" title="Link target outside of Sample">Compline</span></span></p>
<p class="toc-text"><span><span href="#/xhtml/chapter008" title="Link target outside of Sample">Matins</span></span></p>
<p class="toc-text"><span><span href="#/xhtml/chapter009" title="Link target outside of Sample">The Hours of the Day</span></span></p>
<p class="toc-text"><span><span href="#/xhtml/gallery" title="Link target outside of Sample">A Biography of Rumer Godden</span></span></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// contents.vue?7847a6b6